import React, {useLayoutEffect} from 'react'
import {BrowserRouter, useLocation} from 'react-router-dom'
import {I18nFromUrlProvider} from 'i18n/I18nFromUrlProvider'
import {AppTopRoutes} from './routes/AppTopRoutes'
import {SeoLanguageAlternates} from 'seo/SeoLanguageAlternates'
import {IpLocaleSuggestDialog} from 'i18n/IpLocaleSuggestDialog'
import 'assets/styles.scss'
import {ToastContainer} from 'react-toastify'
import {ElementsProvider} from 'stripe/ElementsProvider'
import {FacebookPixelProvider} from 'FacebookPixelProvider'
import {GDPRConsent} from 'GDPRConsent'

if (typeof window !== 'undefined') {
  require('bootstrap/dist/js/bootstrap')
}

const Wrapper = ({children}: any) => {
  const location = useLocation()
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0)
  }, [location.pathname])
  return children
}

function App() {
  return (
    <BrowserRouter>
      <I18nFromUrlProvider>
        <FacebookPixelProvider>
          <Wrapper>
            <ElementsProvider>
              <AppTopRoutes />
            </ElementsProvider>
          </Wrapper>
        </FacebookPixelProvider>
        <SeoLanguageAlternates />
        <IpLocaleSuggestDialog />
        <GDPRConsent />
        <ToastContainer />
      </I18nFromUrlProvider>
    </BrowserRouter>
  )
}

export default App
